import { selectSurvey, selectSurveysByChartId } from '../reducers/selectors/surveys';
import {
	selectAppStateDepolSurveyId,
	selectAppStatePrimaryChartId,
	selectAppStatePrimarySurveyId,
	selectAppStateUseThreshold,
	selectAppStateUseShadow,
	selectAppStateRemediationActions,
	selectAppStateCustomGroups,
	selectAppStateUseInterpolatedDepol,
	selectAppStateUseNormalizedDepol,
	selectAppStateSeriesVisibility,
	selectAppStateLessNegativeThreshold,
	selectAppStateMoreNegativeThreshold,
	selectAppStateSliceChartSettings,
} from '../reducers/slices/AppStateV2/selectors';
import { thunkComputeBelowCriterions } from '../reducers/slices/Charts/slices/ChartsBelowCriterions/actions';
import {
	setRemediationsActions,
	thunkClearCustomGroupRanges,
	thunkSetCustomGroupRanges
} from '../reducers/slices/Charts/slices/ChartsRemediations/actions';
import { addChartSettings } from '../reducers/slices/Charts/slices/ChartsSettings/actions';
import { createInitialChartSettings } from '../reducers/slices/Charts/slices/ChartsSettings/util';
import { selectDataXYMinMax } from '../reducers/slices/StoreXYMinMax/selectors';

const isDefined = v => v !== undefined && v !== null;

export const loadChartSettings = (dispatch, getState) => {
	const stateApp = getState().app;

	const chartId = selectAppStatePrimaryChartId(stateApp);
	const primarySurveyId = selectAppStatePrimarySurveyId(stateApp);
	const primarySurvey = selectSurvey(stateApp, primarySurveyId);
	const depolSurveyId = selectAppStateDepolSurveyId(stateApp);

	const useThreshold = selectAppStateUseThreshold(stateApp);
	const useShadow = selectAppStateUseShadow(stateApp);
	const lessNegativeThreshold = selectAppStateLessNegativeThreshold(stateApp);
	const moreNegativeThreshold = selectAppStateMoreNegativeThreshold(stateApp);

	const allRemediationsActions = selectAppStateRemediationActions(stateApp);
	const remediationsActions =
		(allRemediationsActions || {})[primarySurveyId] || {};

	const customGroups = selectAppStateCustomGroups(stateApp);
	const useInterpolatedDepol = selectAppStateUseInterpolatedDepol(stateApp);
	const useNormalizedDepol = selectAppStateUseNormalizedDepol(stateApp);

	const seriesVisibility = selectAppStateSeriesVisibility(stateApp) || {};

	const _sliceChartsSettings = selectAppStateSliceChartSettings(stateApp) || {};

	// load cloned chart data
	const chartIds = Object.keys(_sliceChartsSettings);
	chartIds.forEach(cId => {
		const survey = (selectSurveysByChartId(getState(), cId) || [])[0];
		const hasThreshold = (survey?.meta || {});
		const settings = _sliceChartsSettings[cId];
		dispatch(
			addChartSettings(cId, {
				...settings,
				useThreshold: !settings.useShadow && hasThreshold
			})
		);
		dispatch(thunkComputeBelowCriterions(cId));
	});

	if (primarySurveyId) {
		// @todo  - find a better place for this transform to live
		// @note - it should likely live in app state actions or chart settings actions
		const baseSettings = { ...createInitialChartSettings(chartId, primarySurvey) };
		const computedSettings = {
			chartId,

			useThreshold,
			useShadow,
			lessNegativeThreshold: isDefined(lessNegativeThreshold) ? lessNegativeThreshold : undefined,
			moreNegativeThreshold: isDefined(moreNegativeThreshold) ? moreNegativeThreshold : undefined,

			useInterpolatedDepol,
			useNormalizedDepol,
			primarySurveyId,
			depolSurveyId,
			seriesVisibility,
			boundaryXYMinMax: selectDataXYMinMax(stateApp, chartId)
		};
		dispatch(
			addChartSettings(chartId, {
				...baseSettings,
				...computedSettings,
			})
		);
		dispatch(thunkClearCustomGroupRanges(chartId));
		dispatch(thunkComputeBelowCriterions(chartId));
		dispatch(thunkSetCustomGroupRanges(chartId, customGroups));
		dispatch(setRemediationsActions(chartId, remediationsActions || {}));
	}
};

export default { loadChartSettings };
